import type { UseQueryResult } from '@tanstack/react-query'
import { useQuery, useQueryClient } from '@tanstack/react-query'

import { useErrorHandler } from '@/features/bidding/hooks/useErrorHandler'
import { pqClient } from '@/features/prequalification/localControl/endpoints/pqClient'
import type { PrequalificationResourceSet } from '@/features/prequalification/types'
import type { UseQueryOptions } from '@/types/queries'

export const GET_LOCAL_PQ_RESOURCE_SETS_API_ID = 'GET_LOCAL_PQ_RESOURCE_SETS'

export type UseLocalPqResourceSetsQueryResult = Omit<UseQueryResult, 'data'> & {
  resourceSets: PrequalificationResourceSet[] | null
}

export function useLocalPqResourceSetsQuery(
  options?: UseQueryOptions<PrequalificationResourceSet[]>,
): UseLocalPqResourceSetsQueryResult {
  const { data, ...queryResult } = useQuery({
    ...options,
    queryFn: () => pqClient.listResourceSets(),
    queryKey: [GET_LOCAL_PQ_RESOURCE_SETS_API_ID],
  })

  useErrorHandler(queryResult.isError)

  return {
    ...queryResult,
    resourceSets: data ?? null,
  }
}

export function useInvalidateLocalPqResourceSetsQuery() {
  const queryClient = useQueryClient()

  return () => queryClient.invalidateQueries({ queryKey: [GET_LOCAL_PQ_RESOURCE_SETS_API_ID] })
}
